var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifyIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77012 22.2326C11.1029 22.2326 12.2505 21.4276 12.7541 20.2786H6.78613C7.28971 21.4276 8.43742 22.2326 9.77012 22.2326Z",
    fill: "#86FFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5008 10.7629V9.33595C16.5008 6.30407 14.4855 3.73434 11.7243 2.89501V1.95404C11.7243 0.876581 10.8477 0 9.77023 0C8.69278 0 7.8162 0.876581 7.8162 1.95404V2.89501C5.05492 3.73434 3.03966 6.30402 3.03966 9.33595V10.7629C3.03966 13.4261 2.02452 15.9514 0.181255 17.8737C0.00061525 18.0621 -0.0501463 18.34 0.0522452 18.5801C0.154637 18.8201 0.390424 18.9759 0.651396 18.9759H18.8891C19.15 18.9759 19.3858 18.8201 19.4882 18.5801C19.5906 18.34 19.5398 18.0621 19.3592 17.8737C17.5159 15.9514 16.5008 13.4261 16.5008 10.7629ZM10.4216 2.63699C10.2072 2.61632 9.98995 2.60538 9.77023 2.60538C9.55051 2.60538 9.33327 2.61632 9.11889 2.63699V1.95404C9.11889 1.59488 9.41108 1.30269 9.77023 1.30269C10.1294 1.30269 10.4216 1.59488 10.4216 1.95404V2.63699Z",
    fill: "#86FFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2382 9.33618C18.2382 9.6959 18.5299 9.98753 18.8896 9.98753C19.2493 9.98753 19.5409 9.6959 19.5409 9.33618C19.5409 6.72646 18.5246 4.27293 16.6793 2.42758C16.425 2.17325 16.0125 2.17321 15.7582 2.42758C15.5038 2.68195 15.5038 3.09434 15.7582 3.34871C17.3575 4.94803 18.2382 7.07441 18.2382 9.33618Z",
    fill: "#86FFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.651345 9.9875C1.01106 9.9875 1.30269 9.69587 1.30269 9.33615C1.30269 7.07442 2.18348 4.94804 3.78275 3.34873C4.03713 3.09436 4.03713 2.68197 3.78275 2.4276C3.52842 2.17322 3.11599 2.17322 2.86162 2.4276C1.01627 4.27294 0 6.72643 0 9.33615C0 9.69587 0.291629 9.9875 0.651345 9.9875Z",
    fill: "#86FFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifyIco);
export default __webpack_public_path__ + "static/media/notifyIco.4672d5680a4e7bf1128588e4d52deafe.svg";
export { ForwardRef as ReactComponent };